import CollectionService from '../../service/CollectionService'
import Collection, { CollectionRetrieve, CollectionStatus } from '../../domain/Collection'

import React, { useState, useEffect } from 'react'
import { Form, Row, Col, notification, Typography, Input, Space, Button, Select, Result } from 'antd'
import { ModeContext } from '../../provider/ModeProvider'
import { useLocation, useNavigate } from 'react-router-dom'
const { Option } = Select
const { Search } = Input
const { Title } = Typography

const CollectionUpdateForm: React.FC = () => {
    const { setMode } = ModeContext()
    const [form] = Form.useForm()
    const [apiNotification, contextNotification] = notification.useNotification()
    const [loading, setLoading] = useState<boolean>(false)
    const [colId, setColId] = useState<string>('')
    const [disabledCollectionId, setDisabledCollectionId] = useState<boolean>(false)
    const [collection, setCollection] = useState<CollectionRetrieve | null>(null)
    const [result, setResult] = useState<boolean>(false)
    const [collectionStatuses, setCollectionStatuses] = useState<CollectionStatus[]>([])
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        // Parse the query string into an object
        const queryParams = new URLSearchParams(location.search)
        const id = queryParams.get('id')
        if (id) {
            setColId(id)
            onSearch(id)
        }
    }, [])

    const handleBack = () => {
        navigate(location.pathname.split('?')[0])
        setMode('')
    }

    const onSearch = (collectionAccountId: string) => {
        setDisabledCollectionId(true)
        setCollectionStatuses([])
        CollectionService.retrieveCollectionAccount(collectionAccountId)
            .then((response) => {
                const collectionAccountStatus = Collection.accountStatuses(response)
                setCollectionStatuses(collectionAccountStatus)

                setCollection(response)
                form.setFieldsValue(response)
            })
            .catch(() => {
                setDisabledCollectionId(false)
                apiNotification.open({
                    message: 'Retrieve Collection Account Failed',
                    description: 'Collection does not exist, please try with another VA Number',
                    placement: 'top',
                })
            })
    }

    const onFinish = () => {
        setLoading(true)

        const values = form.getFieldsValue() as CollectionRetrieve
        CollectionService.updateCollectionAccountStatus({ accountNumber: collection?.accountNumber as string, status: values.status, provider: collection?.provider })
            .then(() => {
                setResult(true)
            })
            .catch(() => {
                setDisabledCollectionId(false)
                apiNotification.open({
                    message: 'Update Collection Failed',
                    description: 'Something went wrong. Please try again later. If the issue keep happening, please contact Customer Support',
                    placement: 'top',
                })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const reset = () => {
        form.resetFields()

        setResult(false)
        setCollection(null)
        setDisabledCollectionId(false)
    }

    return (
        <>
            {contextNotification}
            {result && collection && (
                <Result
                    status="success"
                    title="Update Collection Account Success"
                    subTitle={`Collection Account With Account Number ${collection.accountNumber} Update Successfully`}
                    extra={[
                        <Button type="primary" key="console" onClick={reset}>
                            Back
                        </Button>,
                    ]}
                />
            )}

            <Form name="collection-update" layout="vertical" onFinish={onFinish} form={form}>
                {!result && (
                    <>
                        <Row>
                            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 8 }}>
                                <Title level={5}>Search by VA Number</Title>
                                <Form.Item>
                                    <Search
                                        value={colId}
                                        onChange={(e) => setColId(e.target.value)}
                                        placeholder="Input Collection VA Number"
                                        disabled={disabledCollectionId}
                                        onSearch={onSearch}
                                    />
                                </Form.Item>

                                {collection && (
                                    <>
                                        <Title level={5}>Collection Account Information</Title>
                                        <Form.Item label="Collection Account Name" name="name">
                                            <Input disabled={true} />
                                        </Form.Item>

                                        <Form.Item name="accountId" className={'display-none'}>
                                            <Input disabled={true} />
                                        </Form.Item>

                                        <Form.Item name="collectionAccountId" className={'display-none'}>
                                            <Input disabled={true} />
                                        </Form.Item>

                                        <Form.Item label="Status" name="status">
                                            <Select placeholder="Select Collection Status">
                                                {collectionStatuses.map((status) => (
                                                    <Option key={status.value} value={status.value}>
                                                        {status.description}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </>
                )}
                <Row>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 8 }}>
                        <Form.Item label=" " colon={false}>
                            <Space>
                                {collection && (
                                    <>
                                        <Button type="primary" htmlType="submit" loading={loading}>
                                            Update
                                        </Button>
                                        <Button onClick={reset}>Reset</Button>
                                    </>
                                )}
                                <Button onClick={handleBack}>Back</Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </>
    )
}

export default CollectionUpdateForm
